import React from 'react';
import { TrashIcon } from 'react-open-iconic-svg';

export default class RemoveButton extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      confirming: false,
    }
  }

  cancel = () => {
    this.setState({
      confirming: false,
    });
  }

  confirm = () => {
    this.setState({
      confirming: true,
    });
  }

  render() {
    const confirming = this.state.confirming;
    const className = this.props.className || 'float-end ';
    const disabled = this.props.disabled;
    
    if (confirming) {
      return (
        <div className={className}>
          <span>Точно удалить?</span>
          <button disabled={disabled} type="button" onClick={this.props.remove} className="btn btn-danger me-2">Да</button>   
          <button type="button" onClick={this.cancel} className="btn btn-light me-2">Нет</button>   
        </div>
      );
    }
    
    return (
      <div className={className}>
        <button disabled={disabled} type="button" onClick={this.confirm} className="btn btn-warning">
          <TrashIcon className="icon" viewBox="0 0 8 8" alt="редактировать" />
        </button>
      </div>
    )

  }
}